import { render, staticRenderFns } from "./ListOrbitTransactionsView.vue?vue&type=template&id=79cb8fe8&scoped=true"
import script from "./ListOrbitTransactionsView.vue?vue&type=script&lang=ts"
export * from "./ListOrbitTransactionsView.vue?vue&type=script&lang=ts"
import style0 from "./ListOrbitTransactionsView.vue?vue&type=style&index=0&id=79cb8fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb8fe8",
  null
  
)

export default component.exports